import React, { useState, useRef, useEffect } from "react";
import "./Gigs.scss";
import GigCard from "../../Container/gigCard/GigCard";
import { Link, useLocation } from "react-router-dom";
import newRequest from "../../utils/newRequest";
import { useQuery } from "@tanstack/react-query";

const Gigs = () => {
  const [sort, setSort] = useState("sales");
  const [open, setOpen] = useState(false);
  const minRef = useRef();
  const maxRef = useRef();
  const { search } = useLocation();

  //fetch the data
  const { isLoading, error, data, refetch } = useQuery({
    queryKey: ["gigs"],
    queryFn: () =>
      newRequest
        .get(
          `/gigs${search}&min=${minRef.current.value}&max=${maxRef.current.value}&sort=${sort}`
        )
        .then((res) => {
          return res.data;
        }),
  });

  const reSort = (type) => {
    setSort(type);
    setOpen(false);
  };

  useEffect(() => {
    refetch();
  }, [sort, refetch]);

  const handleApply = () => {
    refetch();
  };

  return (
    <div className="gigs">
      <div className="gigs-container">
        <div className="brudcrumbs">
          <Link className="link" to={"/"}>
            FIVERR
          </Link>
          {">"} GRAPHICS & DESIGN {">"}
        </div>
        <h1>AI Artists</h1>
        <div className="desc">
          Explore the boundaries of art and technology with Liverr's AI artists
        </div>
        <div className="menu">
          <div className="menu-budget">
            <span>Budget</span>
            <input type="number" ref={minRef} placeholder="min" min={1} />
            <input type="number" ref={maxRef} placeholder="max" min={1} />
            <button onClick={handleApply}>Apply</button>
          </div>
          <div className="menu-sort">
            <span className="sortBy">Sort by</span>
            <span className="sortType">
              {sort === "sales" ? "Best Selling" : "Newest"}
            </span>
            <img src="./img/down.png" alt="" onClick={() => setOpen(!open)} />
            {open && (
              <div className="rightMenu">
                {sort === "sales" ? (
                  <span onClick={() => reSort("createdAt")}>Newest</span>
                ) : (
                  <span onClick={() => reSort("sales")}>Best Selling</span>
                )}
                <span onClick={() => reSort("sales")}>Popular</span>
              </div>
            )}
          </div>
        </div>

        <div className="cards">
          {isLoading
            ? "Loading ..."
            : error
            ? "Not found Please try again !"
            : data?.map((gig) => <GigCard key={gig?._id} item={gig} />)}
        </div>
      </div>
    </div>
  );
};

export default Gigs;
